const DETAILS_API_TYPES = {
  PARK: "PARK",
  PARK_AND_FLOW: "PARKANDFLOW",
  PEDESTRIAN_AND_FLOW: "PEDESTRIANANDFLOW",
  FLOW: "FLOW",
  QUEUE_MANAGEMENT: "QUEUEMANAGEMENT",
  TRAFFIC: "TRAFFIC",
};

export { DETAILS_API_TYPES };
